import { StatoPratica } from "./pratica.stato.scuola.model";
import { StatoInfratel } from "./statoInfratel.model";

import { Utente } from "./utente.model";

export class NotaPratica {
    id: Number;
    data: Date;
    utente: Utente;
    contenuto: String;
   
  }
  